import styled from 'styled-components';
import { device } from '../../../ui-components/breakpoints';
import { playGrey15, regularWhite } from '../../../ui-components/design-tokens';
import { playFontIcon, regularOutline } from '../../../ui-components/typography/helpers';
import PlayText from '../../../ui-components/typography/PlayText/PlayText';

export const StyledDevices = styled.div`
    color: ${regularWhite};
    margin-bottom: 30px;
    padding: 40px 0 30px;
    align-items: center;
    border-top: 1px solid ${playGrey15};
    border-bottom: 1px solid ${playGrey15};
    overflow: hidden;
`;

export const StyledDeviceHeader = styled(PlayText)`
    text-align: center;

    span {
        display: block;

        @media ${device.GteSmall} {
            display: inline;
        }
    }
`;

export const StyledDeviceList = styled.ul`
    text-align: center;
    margin: 10px 0 0;
    padding: 0;
`;

export const StyledDevice = styled.li`
    list-style: none;
    display: inline-block;
    margin: 10px 15px;

    @media ${device.GteSmall} {
        margin: 10px 30px;
    }
`;

export const StyledDeviceLink = styled.a`
    color: ${regularWhite};
    text-decoration: none;

    &:focus {
        ${regularOutline()}
    }
`;

export const StyledIconWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
`;

export const StyledIcon = styled.div`
    margin-bottom: 5px;

    &:before {
        ${(props) => playFontIcon(2.5, props.icon)}
    }

    @media ${device.GteSmall} {
        &:before {
            ${(props) => playFontIcon(3, props.icon)}
        }
    }
`;

export const StyledExternalIconText = styled.span`
    text-decoration: underline;
`;
